<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.name"
            :loading="searchLoading"
            allowClear
            placeholder="请输入SN\房间\房型"
            @search="getTableData"
        >
        </a-input-search>
      </div>
    </div>
    <!-- <div class="bar-rig">
      <div class="rig-one" @click="handleOpenModal">
        <a-button class="btn-primary">添加门锁</a-button>
      </div>
    </div> -->
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :customRow="rowClick"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'estatus'">
        <div v-if="record.estatus == 0" class="f-c-red">离线</div>
        <div v-else-if="record.estatus == 1" class="f-c-green">在线</div>
        <div v-else-if="record.estatus == 2">异常</div>
      </template>
      <template v-if="column.key == 'rssi'">
        <div v-if="80 <= record.rssi" class="f-c-green">强</div>
        <div v-else-if="50 <= record.rssi && record.rssi <= 80">一般</div>
        <div
            v-else-if="30 <= record.rssi && record.rssi <= 50"
            style="color: #f38921"
        >
          弱
        </div>
        <div v-else-if="0 < record.rssi && record.rssi <= 30" class="f-c-red">
          较弱
        </div>
        <div v-else class="f-c-999">无信号</div>
      </template>
      <template v-if="column.key == 'operation'">
        <a-button
            type="link"
            @click="goRouter('/pms/landlord/opendoor', record)"
        >开门记录
        </a-button
        >
        <a-button type="link" @click.stop="handleManager(record, -3)"
        >临时密码
        </a-button
        >
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <DownOutlined/>
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item @click.stop="handleManager(record, -1)">
                <div>管理员</div>
              </a-menu-item>
              <a-menu-item @click.stop="handleLockSet(record)">
                <div>门锁设置</div>
              </a-menu-item>
              <a-menu-item @click.stop="handleOpenTime(record)">
                <div>开门持续时长</div>
              </a-menu-item>
              <a-menu-item @click.stop="handleUnBind(record)">
                <div class="f-c-red">解绑</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </template>
  </a-table>

  <!-- 添加弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :confirmLoading="modalLoading"
      :title="modalTitle"
      :width="400"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="SN：" name="sn">
        <a-input
            v-model:value="addForm.sn"
            placeholder="请输入SN"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="房间：" name="hid">
        <a-select
            v-model:value="addForm.hid"
            :filterOption="houseFilter"
            placeholder="请选择房间"
            show-search
            @dropdownVisibleChange="getHouseList"
        >
          <a-select-option
              v-for="(item, index) in houseList"
              :key="index"
              :value="item.id"
          >{{ item.name }}
          </a-select-option
          >
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 管理员临时密码弹窗 -->
  <a-modal
      v-model:visible="visibleManager"
      :confirmLoading="modalLoading"
      :title="modalTitle"
      :width="500"
      class="manager"
      okText="重置密码"
      @ok="resetPwd"
  >
    <a-form
        ref="managerFormRef"
        :label-col="{ span: 5 }"
        :model="managerForm"
        :rules="managerRules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="SN：">
        <a-input
            v-model:value="managerForm.sn"
            disabled
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="房间：">
        <a-input
            v-model:value="managerForm.hname"
            disabled
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="密码：">
        <a-input
            v-model:value="managerForm.pwd"
            disabled
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="到期时间：">
        <a-input
            v-model:value="managerForm.expire_time"
            disabled
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item
          v-if="modalTitle == '临时密码'"
          label="有效时间："
          name="expire_time1"
      >
        <a-select
            v-model:value="managerForm.expire_time1"
            placeholder="请选择临时密码有效时间"
        >
          <a-select-option value="10">10分钟</a-select-option>
          <a-select-option value="20">20分钟</a-select-option>
          <a-select-option value="30">30分钟</a-select-option>
          <a-select-option value="40">40分钟</a-select-option>
          <a-select-option value="50">50分钟</a-select-option>
          <a-select-option value="60">60分钟</a-select-option>
          <a-select-option value="90">90分钟</a-select-option>
          <a-select-option value="100">100分钟</a-select-option>
          <a-select-option value="120">120分钟</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 门锁设置 -->
  <a-modal v-model:visible="visibleLockSet" :width="600" title="门锁设置">
    <a-form
        :label-col="{ span: 12 }"
        :model="lockConfig"
        hideRequiredMark
        labelAlign="left"
    >
      <div class="lockSet">
        <div class="set-lef">
          <a-form-item label="房扫按钮提示音：">
            <a-switch
                v-model:checked="lockConfig.clean_room_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="开门按钮提示音：">
            <a-switch
                v-model:checked="lockConfig.open_key_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="数字按钮提示音：">
            <a-switch
                v-model:checked="lockConfig.num_key_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="人脸识别提示音：">
            <a-switch
                v-model:checked="lockConfig.face_recog_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="开门提示音：">
            <a-switch
                v-model:checked="lockConfig.door_open_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
        </div>
        <div class="set-rig">
          <a-form-item label="身份证读取提示音：">
            <a-switch
                v-model:checked="lockConfig.check_in_idcard_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="人脸识别提示：">
            <a-switch
                v-model:checked="lockConfig.check_in_recong_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="订单核验提示：">
            <a-switch
                v-model:checked="lockConfig.check_in_order_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
          <a-form-item label="防拆警报音：">
            <a-switch
                v-model:checked="lockConfig.dismantle_alarm_voice_sw"
                :checkedValue="1"
                :unCheckedValue="0"
            />
          </a-form-item>
        </div>
      </div>
    </a-form>
    <template #footer>
      <a-button :loading="modalLoading" @click="resetConfig">恢复出厂</a-button>
      <a-button :loading="modalLoading" class="btn-primary" @click="configSave"
      >确定
      </a-button
      >
    </template>
  </a-modal>

  <!-- 开门持续时长 -->
  <a-modal
      v-model:visible="visibleOpenTime"
      :confirmLoading="modalLoading"
      :width="500"
      title="开门持续时长"
      @ok="openTimeSave"
  >
    <a-form
        :label-col="{ span: 6 }"
        :model="lockConfig"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="门锁开门时长：">
        <a-select
            v-model:value="lockConfig.door_open_keep_time"
            placeholder="请选择时长"
        >
          <a-select-option :value="3">3秒</a-select-option>
          <a-select-option :value="6">6秒</a-select-option>
          <a-select-option :value="9">9秒</a-select-option>
          <a-select-option :value="12">12秒</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      class="pagination"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />

  <!-- 详情抽屉 -->
  <a-drawer
      v-model:visible="visibleDrawer"
      :bodyStyle="{ padding: 0 }"
      :closable="false"
      class="drawer"
      placement="right"
      style="color: #000000"
      width="500"
  >
    <div class="header">
      <div class="title f-w-b f-16">{{ detailsData.sn }}</div>
      <div
          v-if="detailsData.estatus == 0"
          class="bar"
          style="background-color: #999999"
      >
        离线
      </div>
      <div
          v-else-if="detailsData.estatus == 1"
          class="bar"
          style="background-color: green"
      >
        在线
      </div>
      <div
          v-else-if="detailsData.estatus == 2"
          class="bar"
          style="background-color: red"
      >
        异常
      </div>
    </div>
    <div class="content">
      <div class="info">
        <div class="lef f-c-999">设备SN：</div>
        <div class="rig">
          {{ detailsData.sn }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">所属房间：</div>
        <div class="rig">{{ detailsData.name }}</div>
      </div>
      <div class="info">
        <div class="lef f-c-999">主版固件：</div>
        <div class="rig">
          {{ detailsData.version_k210 }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">通讯固件：</div>
        <div class="rig">
          {{ detailsData.version_esp32 }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">IEMI：</div>
        <div class="rig">
          {{ detailsData.imei }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">IESI：</div>
        <div class="rig">
          {{ detailsData.imsi }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">卡序列号：</div>
        <div class="rig">
          {{ detailsData.idcard_sn }}
        </div>
      </div>
      <div class="info">
        <div class="lef f-c-999">最近通讯时间：</div>
        <div class="rig">
          {{ detailsData.beat_time }}
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs} from "vue";
import {
  device_bind,
  houselockList,
  lockDetails,
  lockDeviceUnbind,
  lockFactoryConfig,
  lockGetConfig,
  lockList,
  lockSetConfig,
  lockUpdatePassword,
  lockUserInfo,
  setDoorOpenKeepTime,
} from "@/api/api";
import {DownOutlined, ExclamationCircleOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import {message, Modal} from "ant-design-vue";
import router from "@/router/index";

export default {
  components: {
    DownOutlined,
  },
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        name: "",
        start: 0,
        limit: store.getters.getPageSize,
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      detailsData: {},
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "SN",
          dataIndex: "sn",
          key: "sn",
        },
        {
          title: "房间",
          dataIndex: "hname",
          key: "hname",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "房型",
          dataIndex: "rname",
          key: "rname",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "电量",
          dataIndex: "battery",
          key: "battery",
          customRender: ({text}) => {
            if (!text && text !== 0) {
              return "-";
            } else {
              return text + "%";
            }
          },
        },
        {
          title: "信号",
          dataIndex: "rssi",
          key: "rssi",
        },
        {
          title: "状态",
          dataIndex: "estatus",
          key: "estatus",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          align: "center",
          width: 250,
        },
      ],
      getTableData() {
        search.searchLoading = true;
        lockList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      getDetails(item) {
        lockDetails({
          hid: item.hid,
        }).then((res) => {
          table.detailsData = res.data;
          modal.visibleDrawer = true;
        });
      },
      // table 点击行
      rowClick(record) {
        return {
          onClick: () => {
            table.getDetails(record);
          },
          style: "cursor: pointer;",
        };
      },
      goRouter(url, params = {}) {
        router.push({path: url, query: {sn: params.sn}});
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      visibleManager: false,
      visibleDrawer: false,
      modalLoading: false,
      formRef: "", //表单验证
      handleOpenModal() {
        modal.modalTitle = "添加门锁";
        modal.visibleAdd = true;
      },
      managerForm: {
        expire_time1: [],
      },
      managerFormRef: "",
      managerRules: {
        expire_time1: [
          {
            required: true,
            message: "请选择临时密码有效时间",
            trigger: "change",
          },
        ],
      },
      handleManager(item, value) {
        modal.managerForm.sn = item.sn;
        modal.managerForm.hname = item.hname;
        lockUserInfo({
          sn: item.sn,
          type: value,
        }).then((res) => {
          modal.managerForm.pwd = res.data.pwd;
          modal.managerForm.expire_time = res.data.expire_time;
        });
        modal.visibleManager = true;
        if (value == -1) {
          modal.modalTitle = "管理员";
        } else {
          modal.modalTitle = "临时密码";
        }
      },
      resetPwd() {
        modal.managerFormRef.validate().then(() => {
          modal.modalLoading = true;
          lockUpdatePassword({
            sn: modal.managerForm.sn,
            type: modal.modalTitle == "管理员" ? -1 : -3,
            expire_time:
                modal.modalTitle == "管理员"
                    ? ""
                    : modal.managerForm.expire_time1,
          }).then((res) => {
            message.success(res.msg);
            modal.modalLoading = false;
            modal.managerFormRef.resetFields("expire_time1");
            lockUserInfo({
              sn: modal.managerForm.sn,
              type: modal.modalTitle == "管理员" ? -1 : -3,
            }).then((res) => {
              modal.managerForm.pwd = res.data.pwd;
              modal.managerForm.expire_time = res.data.expire_time;
            });
          });
        });
      },
      handleUnBind(item) {
        Modal.confirm({
          title: "确定解绑此门锁？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            lockDeviceUnbind({sn: item.sn, hid: item.hid}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      visibleLockSet: false,
      lockConfig: {},
      handleLockSet(item) {
        modal.modalLoading = true;
        lockGetConfig({sn: item.sn}).then((res) => {
          modal.modalLoading = false;
          modal.lockConfig = res.data;
        });
        modal.visibleLockSet = true;
      },
      configSave() {
        modal.modalLoading = true;
        lockSetConfig(modal.lockConfig).then((res) => {
          message.success(res.msg);
          modal.visibleLockSet = false;
          modal.modalLoading = false;
        });
      },
      resetConfig() {
        modal.modalLoading = true;
        lockFactoryConfig({sn: modal.lockConfig.sn}).then((res) => {
          message.success(res.msg);
          modal.lockConfig = res.data;
          modal.modalLoading = false;
        });
      },
      visibleOpenTime: false,
      handleOpenTime(item) {
        modal.visibleOpenTime = true;
        modal.modalLoading = true;
        lockGetConfig({sn: item.sn}).then((res) => {
          modal.modalLoading = false;
          modal.lockConfig = res.data;
        });
      },
      openTimeSave() {
        modal.modalLoading = true;
        setDoorOpenKeepTime({
          sn: modal.lockConfig.sn,
          keep_time: modal.lockConfig.door_open_keep_time,
        }).then((res) => {
          message.success(res.msg);
          modal.modalLoading = false;
          modal.visibleOpenTime = false;
        });
      },
      addForm: {
        hid: [],
        sn: "",
      },
      rules: {
        sn: [
          {
            required: true,
            message: "请输入SN",
            trigger: "blur",
          },
        ],
        hid: [
          {
            required: true,
            message: "请选择房间",
            trigger: "blur",
            type: "number",
          },
        ],
      },
      // 保存
      addSave() {
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          device_bind(modal.addForm)
              .then((res) => {
                message.success(res.msg);
                nextTick(() => {
                  modal.modalLoading = false;
                  if (modal.formRef) {
                    modal.formRef.resetFields();
                  }
                });
                modal.visibleAdd = false;
                table.getTableData();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
        });
      },
      houseList: [],
      getHouseList() {
        houselockList({
          start: 0,
          limit: 999,
        }).then((res) => {
          modal.houseList = res.data;
        });
      },
      houseFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.lockSet {
  display: flex;
  justify-content: space-between;

  .set-lef {
    width: 300px;
  }

  .set-rig {
    width: 300px;
  }
}

.manager {
  .ant-input[disabled] {
    color: #000000;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 200px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>